import {Component, OnInit} from '@angular/core';
import {EditPermissions, NodeBuilder, NodeFlowDetails} from '../../../../../../../shared/models';
import {FormGroup} from '@angular/forms';
import {DecimalFormatFormType, DecimalFormatNode, NODE_TYPE} from './decimal-format';
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';


@Component({
  selector: 'app-decimal-format',
  templateUrl: './decimal-format.component.html',
  styleUrls: ['./decimal-format.component.scss']
})
export class DecimalFormatComponent extends NodeBuilder implements OnInit {

  // Data From DELEGATOR
  nodeFlowDetails: NodeFlowDetails;
  canEdit: EditPermissions;

  // FormGroups
  actionParams: FormGroup = undefined;
  actionResults: FormGroup = undefined;
  stepUniqueID = '';

  groupSeparatorList = [
    {
      label: '- None -',
      value: 'none'
    },
    {
      label: '.',
      value: '.'
    },
    {
      label: ',',
      value: ','
    },
    {
      label: ' ',
      value: ' '
    }
  ];

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    this.stepUniqueID = stepData.metadata?.stepUniqueID ? stepData.metadata?.stepUniqueID : '';
    const formData: DecimalFormatFormType = DecimalFormatNode.toForm(stepData);
    if (!stepData) {
      return;
    }
    const groupSeparatorValues = this.groupSeparatorList.map(value => value.value);
    if (formData.actionParams.groupSeparator && !groupSeparatorValues.includes(formData.actionParams.groupSeparator)) {
      this.groupSeparatorList.push({label: formData.actionParams.groupSeparator, value: formData.actionParams.groupSeparator});
    }

    this.buildActionParamsForm(formData);
    this.buildActionResultForm(formData);

    // Patch variable success value for new step
    if (this.actionResults.get('success').value === newStepValue) {
      this.actionResults.get('success').setValue('step' + this.getNextStep());
    }
    // Patch variable error value for new step
    if (this.actionResults.get('error').value === newStepValue) {
      this.actionResults.get('error').setValue('step' + this.getNextStep());
    }
  }

  buildActionParamsForm(formData: any) {
    this.actionParams = DecimalFormatNode.getActionParamsTemplate(this.canEdit);
    this.actionParams.patchValue(formData.actionParams);
  }

  buildActionResultForm(formData: any) {
    this.actionResults = DecimalFormatNode.getActionResultTemplate(this.canEdit);
    this.actionResults.patchValue(formData.actionResults);
  }

  get getStepData(): {} {
    const actionParams = this.actionParams.getRawValue();
    const actionResults: any = this.actionResults.getRawValue();

    const decimalFormatNode = new DecimalFormatNode();

    decimalFormatNode.addActionParams(actionParams);
    decimalFormatNode.addActionResult(actionResults);
    const nodeData = decimalFormatNode.nodeData;
    if ( this.stepUniqueID !== '') {
      nodeData['metadata'].stepUniqueID = this.stepUniqueID;
    }

    return nodeData;
  }

  get isNodeValid(): boolean {
    this.actionParams.markAllAsTouched();
    this.actionResults.markAllAsTouched();

    return this.actionParams.valid && this.actionResults.valid;
  }

  addSeparator($event: any, value: string) {
    $event.stopPropagation();
    if (value !== '') {
      this.groupSeparatorList.push({ label: value, value: value});
    }
  }

}
